import React from 'react';

import { FormStep } from './FormStep/FormStep';

export interface FormStepModel {
  title: string;
  content: React.ReactElement;
  step?: number;
  category?: string;
  description?: string;
}

export interface MultiStepFormProps {
  steps: FormStepModel[];
  completedStep?: React.ReactElement;
  isCompleted?: boolean;
  button?: {
    label: string;
    url: string;
  };
  hideControls?: boolean;
  showButton?: boolean;
  currentStep: number;
  maxStep: number;
  lastConfirmedStep?: number;
  customQuestionnaire?: boolean;
  hideModelAndUsecase?: boolean;
  modelQuestionnaire?: boolean;
  hideDraft?: boolean;
  disabledNext?: boolean;
  loadingNext?: boolean;
  lockNavigation?: boolean;
  onBack?: () => void;
  nextText?: string;
  onStepChange?: (step: number) => void;
}

export const MultiStepForm = ({
  button,
  steps,
  completedStep,
  isCompleted,
  hideControls,
  showButton,
  currentStep,
  maxStep,
  lastConfirmedStep,
  customQuestionnaire = false,
  hideModelAndUsecase = false,
  modelQuestionnaire = false,
  hideDraft = false,
  disabledNext = false,
  loadingNext = false,
  lockNavigation = false,
  onBack,
  nextText,
  onStepChange,
}: MultiStepFormProps) => {
  if (isCompleted) {
    return completedStep ?? null;
  }

  const { title, content, description, category, step } = steps[currentStep - 1];

  return (
    <FormStep
      title={title}
      step={currentStep}
      maxStep={maxStep}
      lastConfirmedStep={lastConfirmedStep}
      description={description}
      category={category}
      totalSteps={steps.length}
      formId={step}
      button={button}
      hideControls={hideControls}
      hideModelAndUsecase={hideModelAndUsecase}
      showButton={showButton}
      customQuestionnaire={customQuestionnaire}
      modelQuestionnaire={modelQuestionnaire}
      hideDraft={hideDraft}
      disabledNext={disabledNext}
      loadingNext={loadingNext}
      lockNavigation={lockNavigation}
      onBack={onBack}
      nextText={nextText}
      onStepChange={onStepChange}
    >
      {content}
    </FormStep>
  );
};
